<template>
     <div>
      <new-button @clicked="openContextModal()" />
      <div class="content is-medium">
          <p> Projekt {{ projectDetails.projectCode }}</p>
          <p> Kund: {{ projectDetails.customerName }}</p>
          <p> Ansvarig: {{ projectDetails.projectOwnerUserInitials }}</p>
          <p> Granskare: {{ projectDetails.projectReviewerUserInitials }}</p>
          <p> Fakturaadress:  {{ projectDetails.mainAddress.name }}, {{ projectDetails.mainAddress.streetAddress }}, {{ projectDetails.mainAddress.postalCode }} {{ projectDetails.mainAddress.city }}</p>
          <p> Besställare:  {{ projectDetails.mainContact.firstName }} {{ projectDetails.mainContact.lastName }},
            {{ projectDetails.mainContact.role }}, {{ projectDetails.mainContact.email }} - {{ projectDetails.mainContact.mobilePhone }} - {{ projectDetails.mainContact.phone }} </p>

          <p> Fakturainformation: {{ projectDetails.invoiceText }}</p>
          <p> Betalvillkor: {{ projectDetails.paymentTermDays }} dagar</p>

          <p> Taggar: {{ tagList }}</p>
      </div>
      <h3 class="title">Kontakter</h3>
      <table class="table">
        <thead><th>Namn</th><th>Roll</th><th>E-post</th><th>Mobilnummer</th><th>Direktnummer</th></thead>
        <tbody>
          <tr v-for="contact in projContacts" v-bind:key="contact.contactId">
            <td>{{ contact.firstName }} {{ contact.lastName }}</td>
            <td>{{ contact.role }}</td>
            <td>{{ contact.email }}</td>
            <td>{{ contact.mobilePhone }}</td>
            <td>{{ contact.phone }}</td>
          </tr>
        </tbody>
      </table>

      <h3 class="title">Adresser</h3>
      <table class="table">
        <thead><th>Adresstyp</th><th>Objekt</th><th>Gatuadress</th><th>Postnummer</th><th>Ort</th></thead>
        <tbody>
          <tr v-for="address in projAddresses" v-bind:key="address.addressId">
            <td>{{ address.addressType }}</td>
            <td>{{ address.name }}</td>
            <td>{{ address.streetAddress }}</td>
            <td>{{ address.postalCode }}</td>
            <td>{{ address.city }}</td>
          </tr>
        </tbody>
      </table>

      <h3 class="title">Insatser - Todo?</h3>
      <table class="table">
        <thead><th>Ägare</th><th>Status</th><th>Datum för status</th></thead>
        <tbody>
          <tr v-for="workOrder in projWorkOrders" v-bind:key="workOrder.workOrderId">
            <td>{{ workOrder.workOrderOwnerInitials }}</td>
            <td>{{ workOrder.status }}</td>
            <td>{{ workOrder.statusDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import ContextMenuModal from '@/components/nav/ContextMenuModal'
import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    NewButton,
    ContextMenuModal,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,
      project: {
        'projectId': null,
        'customerId': null,
        'customerName': null,
        'projectCode': null,
        'invoiceText': null,
        'projectOwnerUserId': null,
        'projectOwnerUserInitials': null,
        'projectReviewerUserId': null,
        'projectReviewerUserInitials': null,
        'mainAddressId': null,
        'tags': [],
        'paymentTermDays': null,
        'mainAddress': {
          'addressId': null,
          'customerId': null,
          'customerName': null,
          'addressType': null,
          'streetAddress': null,
          'name': null,
          'postalCode': null,
          'city': null
        },
        'mainContactId': null,
        'mainContact': {
          'contactId': null,
          'customerId': null,
          'customerName': null,
          'role': null,
          'firstName': null,
          'lastName': null,
          'phone': null,
          'mobilePhone': null,
          'email': null,
          'deleted': false
        }
      },
      projContacts: {},
      projAddresses: {},
      projWorkOrders: {},
      projectId: null
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      projects: state => state.projects.all,
      contacts: state => state.contacts.all,
      addresses: state => state.addresses.all,
      workOrders: state => state.workOrders.all
    }),
    projectDetails () {
      return this.project
    },
    projectContacts () {
      return this.projContacts
    },
    projectAddresses () {
      return this.projAddresses
    },
    projectWorkOrders () {
      return this.projWorkOrders
    },
    tagList () {
      let tagNames = this.project.tags.map((tag) => { return tag.name })
      return tagNames.length > 0 ? tagNames.join(', ') : 'Inga'
    }
  },
  methods: {
    ...mapActions('projects', ['getById']),
    ...mapActions({
      getContacts: 'contacts/getContactsByProjectId',
      getAddresses: 'addresses/getAddressesByProjectId',
      getWorkOrders: 'workOrders/getListData'
    }),

    openContextModal () {
      this.$panel(ContextMenuModal, { project: this.project }, 300)
    }
  },
  created () {
    this.projectId = this.$route.params.projectId
    this.getById(this.projectId).then((project) => {
      this.project = project

      this.workOrders.filter = { projectCode: this.project.projectCode }
      this.getWorkOrders().then(() => {
        this.projWorkOrders = this.workOrders.items
      })
    })

    this.getContacts(this.projectId).then((contacts) => {
      this.projContacts = contacts.result
    })

    this.getAddresses(this.projectId).then((addresses) => {
      this.projAddresses = addresses.result
    })
    this.projAddresses = this.getAddresses(this.projectId)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Projects/ProjectDetails.vue